import { useCallback } from 'react';
import { useWhitelabel } from '../auth/hooks/useWhitelabel/useWhitelabel';
import { DocType } from './types';
import { resolveDocUrl } from './resolveDocUrl';

/**
 * Resolve a doc URL for rendering as an `<a href>`, taking the current
 * whitelabel's docs config into account.
 */
export const useResolvedDocUrl = (type: DocType, locale: string): string => {
  const { whitelabelConfig } = useWhitelabel();
  return resolveDocUrl(type, locale, whitelabelConfig?.docs);
};

/**
 * Convenience hook that returns a resolver function, for call sites that
 * need to resolve multiple doc URLs lazily (e.g. inside event handlers).
 */
export const useGetDocUrl = (): ((type: DocType, locale: string) => string) => {
  const { whitelabelConfig } = useWhitelabel();
  const docsConfig = whitelabelConfig?.docs;

  return useCallback(
    (type, locale) => resolveDocUrl(type, locale, docsConfig),
    [docsConfig],
  );
};
